import React from 'react';
import { AttachmentList } from './AttachmentList';
import { Messages } from '../../../../Models/Message';

interface MessageBubbleProps {
  message: Messages;
  isMine: boolean;
  timeAgo: (date: string) => string;
}

export const MessageBubble: React.FC<MessageBubbleProps> = ({
  message,
  isMine,
  timeAgo
}) => (
  <div className={`d-flex ${isMine ? 'justify-content-end' : 'justify-content-start'}`}>
    <div className={`chat-bubble ${isMine ? 'mine' : 'theirs'}`}>
      <div className="bubble-meta">
        <strong className="me-2">{message.displayName}</strong>
        <small>{timeAgo(message.createdAt)}</small>
      </div>
      {message.body && <div className="bubble-body">{message.body}</div>}
      {message.filename && (
        <AttachmentList attachments={message.filename} />
      )}
    </div>
  </div>
);


